import ResizeObserver from 'resize-observer-polyfill';
import {checkHKM} from "../controller/util";

const curryDataType = str => {
  return data => {
    return Object.prototype.toString.apply(data) === str;
  }
}
export const isArray = curryDataType('[object Array]');
export const isDate = curryDataType('[object Date]');
export const isReg = curryDataType('[object RegExp]');
export const isNull = curryDataType('[object Null]');
export const isString = curryDataType('[object String]');
export const isNumber = curryDataType('[object Number]');
export const isUndefined = curryDataType('[object Undefined]');
export const isBoolean = curryDataType('[object Boolean]');
export const isFunction = curryDataType('[object Function]');
// TODO 浏览器不支持，返回为Function
export const isAsyncFunction = curryDataType('[object AsyncFunction]');
export const isObject = curryDataType('[object Object]');
export const isValidNumber = x => isNumber(x) && Number.isFinite(x) && !Number.isNaN(x);
export const isValidArray = x => isArray(x) && x.length > 0;
export const isValidLengthArray = x => isArray(x) && x.length >= 0;
export const isDef = x => !isNull(x) && !isUndefined(x);

const merge = function(target, source) {
  if (!target) return;
  for (let key in source) {
    if (isArray(source[key]) || isArray(target[key])) {
      target[key] = source[key];
    } else if (isObject(source[key])) {
      !target[key] && (target[key] = {});
      merge(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
}
//过滤对象里面的非空字段
export const getObj = function (objs) {
  var obj = deepCopy(objs)
  Object.keys(obj).forEach(function (key) {
    if (obj[key] === '' || obj[key] == null || obj[key].length === 0) {
      delete obj[key]
    }
  })
  return obj;
};
export const deepCopy = function(target, source) {
  if (!target) return;
  if (isObject(source)) {
    for (let key in source) {
      if (isArray(source[key])) {
        target[key] = [];
        deepCopy(target[key], source[key]);
      } else if (isObject(source[key])) {
        target[key] = {};
        deepCopy(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  } else if (isArray(source)) {
    for (let val of source) {
      let newDestination;
      if (isArray(val)) {
        newDestination = [];
        deepCopy(newDestination, val);
      } else if (isObject(val)) {
        newDestination = {};
        deepCopy(newDestination, val);
      } else {
        newDestination = val;
      }
      target.push(newDestination);
    }
  }
  return target;
}
export const mergeOption = function(target, ...sources) {
  if (!target) return;
  for (let source of sources) {
    merge(target, source);
  }
  return target;
}
export const getIndex = (fields, key) => {
  return fields.findIndex(a => a === key);
}
export const mergeModelData = function(model, data) {
  const {model: modelData = {}, ...rest} = data;
  for (let key in model) {
    const modelVal = model[key];
    if (isObject(modelVal)) {

      // 默认是必需的
      const {Required = true, Default, Type, Deep} = modelVal;
      const newVal = rest[key];
      const oldVal = modelData[key];
      if (Required) {
        if (!isDef(newVal)) {
          if (!isDef(oldVal)) {
            throw new Error(`data has no ${key} in model`);
          } else {
            continue;
          }
        }
      }
      if (isDef(newVal)) {
        if (!isDef(oldVal)) {
          if (isFunction(Type)) {
            if (!(newVal instanceof Type || newVal.constructor === Type)) {
              throw new Error(`${key} don\'t match the Type`);
            }
          }
          if (!Deep) {
            modelData[key] = newVal;
          } else {
            if (isObject(newVal)) {
              modelData[key] = deepCopy({}, newVal);
            } else if (isArray(newVal)) {
              modelData[key] = deepCopy([], newVal);
            }
          }
        }
      } else {
        if (isFunction(Default)) {
          modelData[key] = Default();
        } else {
          modelData[key] = Default;
        }
      }
    }
  }
  return {model: modelData, ...rest};
}

export const bind = function(ele, event, fn, isStopPropagation) {
  if (window.addEventListener) {
    ele.addEventListener(event, fn, !!isStopPropagation);
  } else {
    ele.attachEvent('on' + event, fn, !!isStopPropagation);
  }
}
export const unBind = function(ele, event, fn, isStopPropagation) {
  if (window.removeEventListener) {
    ele.removeEventListener(event, fn, !!isStopPropagation);
  } else {
    ele.detachEvent('on' + event, fn, !!isStopPropagation);
  }
}
export const preventScale = function() {
  bind(document, 'touchstart', function(evt) {
    if (evt.touches.length > 1) {
      evt.preventDefault();
    }
  }, true);
  let lastTap = 0;
  bind(document, 'touchend', function(evt) {
    const now = new Date().getTime();
    if (now - lastTap <= 300) {
      evt.preventDefault();
    }
    lastTap = now;
  }, true);
}

/**
 * [监听DOM元素大小变化]
 * @param  {Function} fn       [回调函数]
 * @return {[type]}            [description]
 */
export const resizeObserver = fn => {
  return new ResizeObserver(entries => {
    entries.forEach(entry => {
      fn(entry);
    })
  })
}
/**
 *
 */
export const mutationObserver = (function() {
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  return fn => {
    return new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        fn(mutation);
      })
    })
  }
})();
/**
 * 格式化数据
 */
export const numberFormat = (number, ratioFixed = 2) => {
  if (!isValidNumber(number) || !isValidNumber(ratioFixed)) {
    throw new Error(`${number} or ${ratioFixed} is not a valid number`);
  }
  if(Math.abs(number) > 1000000000000){
      return (Math.abs(number) / 1000000000000).toFixed(ratioFixed) + 'trillion';
  }  else if (number > 100000000) {
    return number > 0 ? (number / 100000000).toFixed(ratioFixed) + 'hundred million': (number / 100000000).toFixed(ratioFixed) + 'hundred million'
  } else if (Math.abs(number) >= 10000) {
    return number > 0?(number / 10000).toFixed(ratioFixed) + 'ten thousand' :(number / 10000).toFixed(ratioFixed)+'ten thousand'
  } else {
    return number.toFixed(0);
  }
}
/*
  表格数据统一处理
 */
export const tableFormat = (key,val,ratioFixed = 2) => {

  let keyRateArr = ["offer_grp1","bid_grp1","px_change", "last_px","bid_grp","offer_grp","preclose_px","open_px","high_px","low_px","w52_high_px","w52_low_px"],
      keyAmountArr = [
        "business_amount",
        "business_balance",
        "business_amount_out",
        "amount",
        "amount_delta",
        "entrust_diff",
        "business_amount_in"
      ],
      keyRangeArr = [
        "px_change_rate",
        "min5_chgpct",
        "entrust_rate",
        "turnover_ratio",
        "vol_ratio",
        "amplitude",
      ],
      keyTotalArr = ["dyn_pb_rate","pe_rate","circulation_value","market_value"]

  if(keyRateArr.includes(key)){
    if(key == "px_change"){
      (!val || val == "0.0")?val= (0).toFixed(ratioFixed) : val = Number(val).toFixed(ratioFixed)
    }else{
      (!val || val == "0.0")?val='--': val = Number(val).toFixed(ratioFixed)
    }
  }else if(keyRangeArr.includes(key)){
    val = Number(val).toFixed(2)
  }else if(keyAmountArr.includes(key)){
    (!val)? val = 0: val = numberFormat(val)
  }else if(keyTotalArr.includes(key)){
    if(key == "dyn_pb_rate" || key == "pe_rate"){
      val?val = Number(val).toFixed(2):val = "--"
    }else{
      val?val = numberFormat(val):val = "--"
    }
  }
  return val
}
export const tableFormat1 = (key,val,ratioFixed = 2) => {

  let defaultShowArr = ["last_px",
                        "px_change_rate",
                        "px_change",
                        "min5_chgpct",
                        "business_amount",
                        "business_balance",
                        "turnover_ratio",
                        "amplitude",
                        "vol_ratio",
                        "entrust_rate",
                        "entrust_diff",
                        "business_amount_in",
                        "bid_grp",
                        "offer_grp",
                        "preclose_px",
                        "open_px",
                        "high_px",
                        "low_px",
                        "business_amount_out",
                        "w52_high_px",
                        "w52_low_px",
                        "bid_grp1",
                        "offer_grp1",
                        "amount",
                        "amount_delta",
                  ],
    keyTotalArr = ["pe_rate","dyn_pb_rate","circulation_value","market_value"]
  if(defaultShowArr.includes(key)){
    val = "--"
  }else if(keyTotalArr.includes(key)){
    if(key == "dyn_pb_rate" || key == "pe_rate"){
      val?val = Number(val).toFixed(2):val = "--"
    }else{
      val?val = numberFormat(val):val = "--"
    }
  }
  return val
}


/*债券表格数据统一处理*/
export const bondFormat = (key,val,ratioFixed = 2) => {

  let defaultShowArr = [
      "latest_rate",
      "weighted_average",
      "last_px",
      "high_px",
      "low_px",
      "business_final_px",
    ],
    keyTotalArr = ["business_amount"]
  if(defaultShowArr.includes(key)){
    val?val = Number(val).toFixed(ratioFixed): val = '--'
  }else if(keyTotalArr.includes(key)){
    val?val: val = "--"
  }
  return val
}
/*货币表格数据统一处理*/
export const currencyFormat = (key,val,ratioFixed = 2) => {
  let defaultShowArr = [
      /*通用字段*/
      /*外汇字段*/
      "best_buy",
      "best_sell",
      "px_change",
      "last_px",
      "open_px",
      "down_px",
      "up_px",
      "special_close_px",
      "business_term_3M",
      "business_term_6M",
      /*货币字段*/
      "weighted_avg",
      "lastest_price",
      "high_px",
      "low_px",
      "last_wavg_px",
      "business_final_px",
      "five_days",
      "ten_days",
      "twenty_days",
      "to_buy",
      "to_sell",
      "mean_val",
    ],
    rateShowArr = [
      "avg_px_change",
      "px_change",
    ],
    keyTotalArr = ["business_amount"]
  if(defaultShowArr.includes(key)){
    val?val = Number(val).toFixed(ratioFixed): val = '--'
  }else if(keyTotalArr.includes(key)){
    val?val = numberFormat(val):val = "--"
  }else if(rateShowArr.includes(key)){
    val?val = Number(val).toFixed(2): val = '--'
  }
  return val
}
/**
 * 浮点数据
 */
export const dealFloat = (number1,number12, ratioFixed = 2) => {
  let bigNumber1 = number1*Math.pow(10,ratioFixed)
  let bigNumber2 = number1*Math.pow(10,ratioFixed)
  const result = (bigNumber1 - bigNumber2)/Math.pow(10,ratioFixed)
  return result.toFixed(ratioFixed)
}

/*
检查是否期货
 */
export const checkFutures = (code,type = 'en_ch_sh') => {
  let _data = [];
  //国内
  const chFurures = [ 'CFFE', 'CCFX', 'SHFE', 'XSGE', 'DCE', 'XDCE', 'CZCE', 'XZCE', 'SHGE', 'SGE' ];
  //国外
  const enFurures = [ 'XCBT', 'CBOT', 'XLME', 'LME', 'XNYM', 'NYMEX', 'XCEC', 'COMEX', 'CME', 'CMES', 'CBOTMINI', 'XCBM' ];
  //上海能源期货交易中心
  const shFurures = [ 'XINE','INE' ]
  const data = type.split('_').map(item=>item+'Furures')
  const fururesAll = { 'chFurures':chFurures,'enFurures':enFurures,'shFurures':shFurures }
  data.forEach(d => {
    const last = fururesAll[d]
    _data = [..._data, ...last];
  });
  return _data.some(a => new RegExp(a).test(code));
}
/**
 * 格式化交易量
 */
export const TradVolume = (number, code,perHand,type = 2,close_px = 0) => {
  if(number===0||number=='-'){
    if(close_px == 0){
      return '--'
    }else {
      return '0'
    }
  }
  const future = checkFutures(code,'ch')
  const HKM = checkHKM(code)
  const hundredList = ['.XBHS', '.CNI', '.GZZS', '.ZZZS', '.CSI']//需要除以100
  //number:传入的成交量，接口返回的值，code当前的code代码，perhand,当前代码的股数和手数转换接口返回type:2=>默认显示数量+股转换，1=>显示数量，0=>不显示
  // const asidePerHand = ['.XSHG','.SS','.XSHE','.SZ','.XSB','.NEEQ','.XBHS','.CNI','.CSI']
  const asidePerHand = ['.XSHG','.SS','.XSHE','.SZ','.XSB','.NEEQ']
  const indexPointCode = code.slice(code.lastIndexOf('.'))
  const noPerHand = asidePerHand.some(item=>{
    const reg = new RegExp("^"+item+"$","g")
    return reg.test(indexPointCode)
  })
  const hundrenHand = hundredList.some(item=>{
    const reg = new RegExp("^"+item+"$","g")
    return reg.test(indexPointCode)
  })
  let text,data,unit = '';
  if(noPerHand){
    data = number / perHand
    unit = 'hands'
  }else if(hundrenHand){
    data = number / 100
    unit = 'hands'
  } else {
    //期货的不显示第二单位其它都显示第二单位
    data = number;
    if(HKM){
      unit = 'thigh'
    }
    // if(!future){
    //   unit = '股'
    // }
  }
  if (Math.abs(data) < 10000) {
    // text = data+unit
    text = parseInt(data) + unit
  } else if(Math.abs(data) < 100000000 && Math.abs(data) >= 10000) {
    text = (data/10000).toFixed(2) + 'ten thousand ' + unit
  } else {
    text = (data/100000000).toFixed(2) + ' hundred million ' + unit
  }
  // const chReg = new RegExp("[\\u4E00-\\u9FFF]+","g");
  const index = escape(text).indexOf( "%u" )
  return index==-1?text:text.slice(0,index+type)
}
/**
 * 订阅数据
 */
export const watch = ({target, key, fn, context, args}) => {
  const property = Object.getOwnPropertyDescriptor(target, key);
  const getter = property && property.get;
  const setter = property && property.set;
  let val = target[key];
  Object.defineProperty(target, key, {
    get: function() {
      const value = getter ? getter.call(target) : val;
      return value;
    },
    set: function(newVal) {
      const value = getter ? getter.call(obj) : val;
      if (newVal === value) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      fn.apply(context, args);
    }
  })
}

export const hasClass = (ele, className = '') => {
  const classNames = ele.className.split(/\s+/);
  return classNames.some(a => new RegExp('^' + className + '$', 'i').test(a))
}
export const addClass = (ele, className = '') => {
  const isHasClass = hasClass(ele, className);
  if (!isHasClass) {
    const classNames = ele.className.split(/\s+/).filter(a => !/^\s*$/.test(a));
    classNames.push(className);
    ele.className = classNames.join(' ');
  }
}
export const removeClass = (ele, className = '') => {
  const isHasClass = hasClass(ele, className);
  if (isHasClass) {
    const classNames = ele.className.split(/\s+/).filter(a => !new RegExp('^' + className + '$', 'i').test(a));
    ele.className = classNames.join(' ');
  }
}
/**
 * 防抖柯里化
 */
export const curryDebounce = function(fn, context, duration) {
  const args = [].slice.call(arguments, 3);
  let timer = null;
  return function() {
    clearTimeout(timer);
    const finalArgs = [...args, ...[].slice.call(arguments)];
    timer = setTimeout(() => {
      fn.apply(context, finalArgs)
    }, duration);
  }
}
/**
 * 节流
 */
export const curryThrottle = function(fn, context, duration) {
  const args = [].slice.call(arguments, 3);
  let timer = new Date().getTime();
  return function() {
    const nowTime = new Date().getTime();
    if (nowTime - timer > duration) {
      const finalArgs = [...args, ...[].slice.call(arguments)];
      fn.apply(context, finalArgs);
      timer = nowTime;
    }
  }
}
/**
 * object参数函数柯里化
 */
export const curryFun = function(fn, context) {
  const args = [].slice.call(arguments, 2);
  const arg = args.shift();
  return function() {
    const innerArg = [].shift.call(arguments);
    if (!isObject(arg) || !isObject(innerArg)) {
      throw new Error(`arguments is not a object`);
    }
    const finalArg = {...arg, ...innerArg};
    fn.call(context, finalArg);
  }
}
/* 时间戳格式化 */
export const timestampToTime= function(timestamp) {
        let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        let D = date.getDate() + ' ';
        let h = date.getHours() + ':';
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes();
        let s = date.getSeconds();
        return h+m;
}
/* 时间戳处理 */
export const dateToTime = function(number,ratioFixed = 2){
  if (number > 10000000) {
    return  (number / 10000000).toFixed(ratioFixed).replace('.',":")
  }
}
/**
 *
 */
export const nextTick = (function() {
  if (isDef(process) && isFunction(process.nextTick)) {
    return process.nextTick;
  } else {
    return fn => Promise.resolve().then(fn);
  }
})();

const Util = {
  isNumber,
  isNull,
  isBoolean,
  isString,
  isUndefined,

  isFunction,
  isAsyncFunction,
  isReg,
  isObject,
  isArray,

  isDef,
  isValidNumber,
  isValidArray,
  isValidLengthArray,
  timestampToTime,
  dateToTime
}
export default Util;
